import api from './api';
import { handleResponse, handleError } from './api';

/**
 * People tab activity — "what your people are doing": friends' started parties /
 * Party Starters, and friend joins you're not in yet. Radius-aware.
 */
const peopleService = {
  async getActivity({ lat = null, lng = null } = {}) {
    const params = {};
    if (lat != null) params.lat = lat;
    if (lng != null) params.lng = lng;
    try { return handleResponse(await api.get('/people/activity', { params })); }
    catch (e) { return handleError(e); }
  },
};

export default peopleService;
